import { Observable, observe, Scope } from 'wdc-cube'
import type { Nfe } from './types'
import { WaitingScope } from 'src/components/waiting/waiting.scopes'

export type CompanyPartner = {
    CpfCnpj: string
    Nome: string
    Qualificacao: string
    QualificacaoRepresentanteLegal: string
}

export type PersonRow = {
    CnpjCpf: string
    Nome: string
    NomeFantasia: string
    Porte: string
    ReceitaSituacao: string
    ReceitaAbertura: Date
    ReceitaAtividade: string
    VaduAtividadeCNAE: string
    ReceitaCapitalSocial: number
    Filiais: string[]
    Telefones: string[]
    Emails: string[]
    Socios: CompanyPartner[]
}

@Observable
export class HeaderScope extends Scope {}

@Observable
export class SerproScope extends Scope {
    readonly header = new HeaderScope()

    @observe() waiting?: WaitingScope

    @observe() persons = [] as PersonRow[]
    @observe() nfe?: Nfe
    @observe() chaveNfeSelected = ''

    onFind = Scope.ASYNC_ACTION
}

export default SerproScope
